import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Delete catering cart API Call
 * @param {Object} cartData - Cart deletion details
 * @returns {Promise<Object>} - Response data from the API
 */
export const deleteCateringCart = async (cartData) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.DELETE_CATERING_CART, cartData);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
